import React, {Component} from "react";
import './Map.css';
import OlMap from "ol/Map";
import OlView from "ol/View";
import OlLayerTile from "ol/layer/Tile";
import OlSourceXYZ from "ol/source/XYZ";
import OlSourceWMS from 'ol/source/ImageWMS';
import OlLayerImage from 'ol/layer/Image';
import OlFeature from 'ol/Feature';
import OlSourceVector from 'ol/source/Vector';
import OlLayerVector from 'ol/layer/Vector';
import OlStyle from 'ol/style/Style';
import OlCircleStyle from 'ol/style/Circle';
import OlStroke from 'ol/style/Stroke';
import OlFill from 'ol/style/Fill';
import OlPoint from 'ol/geom/Point';
import {LocationIcon, MilestoneIcon, ScreenFullIcon, DownloadIcon, GearIcon, XIcon} from '@primer/octicons-react';
import OlMouseControl from 'ol/control/MousePosition';
import {defaults as defaultControls} from 'ol/control';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import FormLabel from "react-bootstrap/FormLabel";
import FormGroup from "react-bootstrap/FormGroup";
import Form from "react-bootstrap/Form";
import RegularShape from "ol/style/RegularShape";
import packageJson from '../../../package.json';
import {Slider, Rail, Handles, Tracks} from "react-compound-slider";

const { version } = packageJson;

const sliderStyle = {
    position: 'relative',
    width: '100%',
    height: 80
};

const railStyle = {
    position: 'absolute',
    width: '100%',
    height: 10,
    marginTop: 35,
    borderRadius: 5,
    backgroundColor: '#d7d7d7',
};

function Track({source, target, getTrackProps}) { // your own track component
    return (
        <div
            style={{
                position: 'absolute',
                height: 10,
                zIndex: 1,
                marginTop: 35,
                backgroundColor: 'darkgrey',
                borderRadius: 5,
                cursor: 'pointer',
                left: `${source.percent}%`,
                width: `${target.percent - source.percent}%`,
            }}
            {...getTrackProps()} // this will set up events if you want it to be clickeable (optional)
        />
    )
}

export function Handle({ // your handle component
                           handle: {id, value, percent},
                           getHandleProps
                       }) {
    return (
        <div
            style={{
                left: `${percent}%`,
                position: 'absolute',
                marginLeft: -15,
                marginTop: 25,
                zIndex: 2,
                width: 30,
                height: 30,
                border: 0,
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: 'white',
                color: 'white',
            }}
            {...getHandleProps(id)}
        >
            <div style={{fontFamily: 'Roboto', fontSize: 11, marginTop: -35}}>
                {value}
            </div>
        </div>
    )
}


const textes = {
    'coordonee': {
        'fr': 'Coordonnées',
        'de': 'Koordinaten',
        'it': 'Coordinate',
        'en': 'Coordinates'
    },
    'aller': {
        'fr': 'Aller aux coordonnées',
        'de': 'Aller aux coordonnées',
        'it': 'Aller aux coordonnées',
        'en': 'Go to coordinates'
    },
    'allerprompt': {
        'fr': 'Entrer des coordonées, séparer X et Y par un espace (CH1903/LV03)',
        'de': 'Entrer des coordonées, séparer X et Y par un espace (CH1903/LV03)',
        'it': 'Entrer des coordonées, séparer X et Y par un espace (CH1903/LV03)',
        'en': 'Please enter coordinates, separate X and Y with a space (CH1903/LV03)',
    },
    'afficher': {
        'fr': 'Afficher la Suisse entière',
        'de': 'Die ganze Schweiz anzeigen',
        'it': 'Mostra tutta la Svizzera',
        'en': 'Zoom to Switzerland'
    },
    'position': {
        'fr': 'Afficher votre position',
        'de': 'Ihren Standort anzeigen',
        'it': 'Visualizza la tua posizione',
        'en': 'Show you position'
    },
    'telecharger': {
        'fr': 'Télécharger la carte',
        'de': 'Karte herunterladen',
        'it': 'Scaricare la mappa',
        'en': 'Download the map'
    },
    'fondcarte': {
        'fr': 'Fond de carte',
        'de': 'Hintergrund',
        'it': 'Sfondo',
        'en': 'Background'
    },
    'cartepixel': {
        'fr': 'Carte pixel',
        'de': 'Pixelkarte',
        'it': 'Carta pixel',
        'en': 'Pixelmap'
    },
    'carteaero': {
        'fr': 'Photo aérienne',
        'de': 'Luftbild',
        'it': 'Veduta aerea',
        'en': 'Aerial imagery'
    },
    'cantons': {
        'fr': 'Limites cantonales',
        'de': 'Kantonsgrenzen',
        'it': 'Frontiere cantonali',
        'en': 'Cantonal boundaries'
    },
    'biogeo': {
        'fr': 'Régions biogéographiques',
        'de': 'Biogeographischen Regionen ',
        'it': 'Regioni biogeografiche',
        'en': 'Biogeographical regions'
    },
    'aucune': {
        'fr': 'Aucune',
        'de': 'Keine',
        'it': 'Aucune',
        'en': 'None'
    },
    'annee': {
        'fr': 'Année charnière',
        'de': 'Grenzjahr',
        'it': 'Anno di svolta',
        'en': 'Threshold year'
    },
    'changer': {
        'fr': 'Changer',
        'de': 'Wechseln',
        'it': 'Cambiare',
        'en': 'Change'
    },
    'coucheacc': {
        'fr': 'Couche accessoire',
        'de': 'Zusätzliche Schicht',
        'it': 'Strato accessorio',
        'en': 'Accessory layer'
    },
    'preference': {
        'fr': 'Préférences',
        'de': 'Einstellungen',
        'it': 'Impostazioni',
        'en': 'Settings'
    }
};

class Map extends Component {
    constructor(props) {
        super(props);

        this.state = {
            center: [810000, 5900000],
            zoom: 8,
            yearChange: localStorage.getItem('if.carto.yc') ? localStorage.getItem('if.carto.yc') : 2000,
            nuesp: props.nuesp,
            mapbg: localStorage.getItem('if.carto.bg') ? localStorage.getItem('if.carto.bg') : 'pixel',
            pixel: props.pixel,
            locale: props.locale,
            dlLink: props.nuesp ? "https://mapserver.infofauna.ch?map=/etc/mapserver/htdocs/ch.map&layer=ch&layer=lacs&layer=rivieres&layer=hillsh&layer=ch&layer=obs&layer=obs1990&layer=obs_5152&layer=obs1990_5152&mode=map&nuesp=" + String(props.nuesp) + "&year=2000": null,
            openClass: 'footer-panel footer-panel-close',
            iconClass: 'footer-panel-icon',
            panelHidden: true,
            ug: localStorage.getItem('if.carto.ug') ? localStorage.getItem('if.carto.ug') : 'none',
        };

        this.mousePosition = React.createRef();

        proj4.defs('EPSG:21781',
            '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 ' +
            '+x_0=600000 +y_0=200000 +ellps=bessel ' +
            '+towgs84=660.077,13.551,369.344,2.484,1.783,2.939,5.66 +units=m +no_defs');
        proj4.defs("EPSG:2056", "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs");
        register(proj4);

        let formatMillier = function (nombre) {
            nombre += '';
            let sep = '\'';
            let reg = /(\d+)(\d{3})/;
            while (reg.test(nombre)) {
                nombre = nombre.replace(reg, '$1' + sep + '$2');
            }
            return nombre;
        };

        let myFormat = function () {
            return (
                function (coord1) {
                    let coord2 = proj4('EPSG:3857', 'EPSG:2056', coord1);
                    coord2 = [formatMillier(Math.round(coord2[0])), formatMillier(Math.round(coord2[1]))];
                    return coord2[0] + ', ' + coord2[1];
                });
        };

        this.locationCircle = new OlFeature();
        this.highlightFeature = new OlFeature();

        this.olSourceWMS = new OlSourceWMS({
            url: 'https://mapserver.infofauna.ch?map=/etc/mapserver/htdocs/wgsCH.map&',
            params: {
                'LAYERS': 'sites',
                'VERSION': '1.1.1',
                'FORMAT': 'image/png; mode=8bit',
                'nuesp': props.nuesp,
                'year': this.state.yearChange
            },
            serverType: 'mapserver',
            crossOrigin: 'anonymous'
        });

        this.biogeoLayer = new OlLayerImage({
            source: new OlSourceWMS({
                url: 'https://mapserver.infofauna.ch?map=/etc/mapserver/htdocs/wgsCH.map&',
                params: {
                    'LAYERS': 'biogeo',
                    'VERSION': '1.1.1',
                    'FORMAT': 'image/png; mode=8bit'
                },
                serverType: ('mapserver'),
                crossOrigin: 'anonymous'
            })
        });

        this.cantonLayer = new OlLayerImage({
            source: new OlSourceWMS({
                url: 'https://mapserver.infofauna.ch?map=/etc/mapserver/htdocs/wgsCH.map&',
                params: {
                    'LAYERS': 'cantons',
                    'VERSION': '1.1.1',
                    'FORMAT': 'image/png; mode=8bit'
                },
                serverType: ('mapserver'),
                crossOrigin: 'anonymous'
            })
        });

        this.olLayerWMS = new OlLayerImage({
            name: 'sites',
            source: this.olSourceWMS
        });

        this.olSourcePixelMap = new OlSourceXYZ({
            url: 'https://wmts10.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg',
            crossOrigin: 'anonymous'
        });

        this.olSourceSwissImage = new OlSourceXYZ({
            url: 'https://wmts10.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/current/3857/{z}/{x}/{y}.jpeg',
            crossOrigin: 'anonymous'
        });

        this.mousePositionControl = new OlMouseControl({
            coordinateFormat: myFormat(0),
            projection: 'EPSG:3857',
            undefinedHTML: ''
        });

        this.highlightShape = new RegularShape({
            radius: 20,
            points: 4,
            fill: new OlFill({
                color: 'cyan'
            }),
            stroke: new OlStroke({
                color: 'cyan',
                width: 3
            }),
            angle: Math.PI / 4
        });

        this.olmap = new OlMap({
            controls: defaultControls().extend([this.mousePositionControl]),
            target: null,
            layers: [
                new OlLayerTile({
                    source: this.state.mapbg === 'pixel' ? this.olSourcePixelMap : this.olSourceSwissImage
                }),
                this.olLayerWMS,
                new OlLayerVector({
                    source: new OlSourceVector({
                        features: [this.locationCircle]
                    }),
                    style: new OlStyle({
                        stroke: new OlStroke({
                            color: '#034d7c',
                            width: 3
                        }),
                        image: new OlCircleStyle({
                            radius: 7,
                            fill: new OlFill({
                                color: '#034d7c'
                            })
                        })
                    }),
                }),
                new OlLayerVector({
                    source: new OlSourceVector({
                        features: [this.highlightFeature]
                    }),
                    render: 'vector',
                    updateWhileAnimating: true,
                    updateWhileInteracting: true,
                    style: new OlStyle({
                        image: this.highlightShape
                    })
                })
            ],
            view: new OlView({
                center: this.state.center,
                zoom: this.state.zoom,
                maxZoom: 14,
                minZoom: 8
            })
        });

        // Centrage initial via les paramètres d'URL ?x=...&y=... (MN03 ou MN95)
        let urlParams = new URLSearchParams(window.location.search);
        let urlX = parseFloat(urlParams.get('x'));
        let urlY = parseFloat(urlParams.get('y'));
        if (!isNaN(urlX) && !isNaN(urlY)) {
            let srs = urlX > 2000000 ? 'EPSG:2056' : 'EPSG:21781';
            let urlCoords = proj4(srs, 'EPSG:3857', [urlX, urlY]);
            this.olmap.getView().setCenter(urlCoords);
            this.olmap.getView().setZoom(12);

            // Croix sur la position demandée (liseré blanc + croix rouge pour rester lisible sur tous les fonds)
            let crossShape = (color, width) => new RegularShape({
                points: 4,
                radius: 12,
                radius2: 0,
                angle: 0,
                stroke: new OlStroke({color: color, width: width})
            });
            this.olmap.addLayer(new OlLayerVector({
                source: new OlSourceVector({
                    features: [new OlFeature(new OlPoint(urlCoords))]
                }),
                style: [
                    new OlStyle({image: crossShape('white', 5)}),
                    new OlStyle({image: crossShape('red', 2)})
                ],
                zIndex: 10
            }));
        }

        let that = this;

        if (props.nuesp) {
            this.olSourceWMS.updateParams({
                nuesp: props.nuesp
            });

            this.olmap.on('pointermove', function (e) {
                if (e.dragging) return;

                let hit = that.olmap.forEachLayerAtPixel(e.pixel, function (layer) {
                    return layer.get('name') === 'sites';
                });
                that.olmap.getViewport().style.cursor = hit ? 'pointer' : '';
            });

            this.olmap.on('click', function (e) {
                let hit = that.olmap.forEachLayerAtPixel(e.pixel, function (layer) {
                    return layer.get('name') === 'sites';
                });
                if (hit) {
                    let coords = proj4('EPSG:3857', 'EPSG:21781', e.coordinate);
                    let n5coords = [Math.floor(coords[0] / 5000) * 5000 + 2500, Math.floor(coords[1] / 5000) * 5000 + 2500];
                    that.setState({
                        pixel: coords
                    });
                    that.highlightFeature.setGeometry(new OlPoint(proj4('EPSG:21781', 'EPSG:3857', n5coords)));
                    that.props.callBackFromParent(coords);
                } else {
                    that.setState({
                        pixel: null
                    });
                    that.props.callBackFromParent(null);
                    that.highlightFeature.setGeometry(null);
                }
            });

            this.olmap.on('postrender', function (e) {
                that.highlightShape.setScale(1 / (that.olmap.getView().getResolution() / 170));
            })
        }

        if (this.state.ug === 'biogeo') {
            this.olmap.addLayer(this.biogeoLayer)
        }
        if (this.state.ug === 'ct') {
            this.olmap.addLayer(this.cantonLayer)
        }

        this.findLocation = this.findLocation.bind(this);
        this.zoomBack = this.zoomBack.bind(this);
        this.goToLocation = this.goToLocation.bind(this);
        this.openPanel = this.openPanel.bind(this);
        this.closePanel = this.closePanel.bind(this);
        this.bgChange = this.bgChange.bind(this);
        this.ugChange = this.ugChange.bind(this);
        this.yrChange = this.yrChange.bind(this);

        this.props.yrChangeCallBack(this.state.yearChange);
    }

    componentDidMount() {
        this.mousePositionControl.setTarget(this.mousePosition);
        this.olmap.setTarget("map");
    }

    shouldComponentUpdate(nextProps, nextState) {
        let that = this;
        if (this.props.nuesp !== nextProps.nuesp) {
            this.setState({
                nuesp: nextProps.nuesp,
                dlLink: "https://mapserver.infofauna.ch?map=/etc/mapserver/htdocs/ch.map&layer=ch&layer=lacs&layer=rivieres&layer=hillsh&layer=ch&layer=obs&layer=obs1990&layer=obs_5152&layer=obs1990_5152&mode=map&nuesp=" + String(nextProps.nuesp) + "&year=2000"
            });

            this.olSourceWMS.updateParams({
                nuesp: nextProps.nuesp
            });

            this.olmap.on('pointermove', function (e) {
                if (e.dragging) return;

                let hit = that.olmap.forEachLayerAtPixel(e.pixel, function (layer) {
                    return layer.get('name') === 'sites';
                });
                that.olmap.getViewport().style.cursor = hit ? 'pointer' : '';
            });

            this.olmap.on('click', function (e) {
                let hit = that.olmap.forEachLayerAtPixel(e.pixel, function (layer) {
                    return layer.get('name') === 'sites';
                });
                if (hit) {
                    let coords = proj4('EPSG:3857', 'EPSG:21781', e.coordinate);
                    let n5coords = [Math.floor(coords[0] / 5000) * 5000 + 2500, Math.floor(coords[1] / 5000) * 5000 + 2500];
                    that.setState({
                        pixel: coords
                    });
                    that.highlightFeature.setGeometry(new OlPoint(proj4('EPSG:21781', 'EPSG:3857', n5coords)));
                    that.props.callBackFromParent(coords);
                } else {
                    that.setState({
                        pixel: null
                    });
                    that.props.callBackFromParent(null);
                    that.highlightFeature.setGeometry(null);
                }
            });

            this.olmap.on('postrender', function (e) {
                that.highlightShape.setScale(1 / (that.olmap.getView().getResolution() / 170));
            })
        }
        if (this.props.locale !== nextProps.locale) {
            this.setState({
                locale: nextProps.locale
            })
        }

        return true;
    }

    findLocation() {
        let that = this;

        navigator.geolocation.getCurrentPosition(
            function (r) {
                that.olmap.getView().setCenter(proj4('EPSG:4326', 'EPSG:3857', [r.coords.longitude, r.coords.latitude]));
                that.olmap.getView().setZoom(14);
                that.locationCircle.setGeometry(r.coords ?
                    new OlPoint(proj4('EPSG:4326', 'EPSG:3857', [r.coords.longitude, r.coords.latitude])) : null);
            },
            function (err) {
                console.log(err);
            }
        );
    }

    zoomBack() {
        this.olmap.getView().setZoom(8);
        this.olmap.getView().setCenter([810000, 5900000]);
    }

    goToLocation() {
        let defaultCoords;
        if (localStorage.getItem('if.carto.coords') === null) {
            defaultCoords = '600000 200000'
        } else {
            defaultCoords = JSON.parse(localStorage.getItem('if.carto.coords')).join(' ');
        }
        let coords = prompt(textes.allerprompt[this.state.locale], defaultCoords);
        if (coords) {
            this.olmap.getView().setZoom(12);
            let cCoords = [];
            coords.split(' ').forEach((item) => {
                cCoords.push(+item);
            });
            this.olmap.getView().setCenter(proj4('EPSG:21781', 'EPSG:3857', cCoords));
            localStorage.setItem('if.carto.coords', JSON.stringify(cCoords));
        }
    }

    openPanel(e) {
        this.setState({
            openClass: 'footer-panel',
            panelHidden: !this.state.panelHidden
        })
    }

    closePanel(e) {
        this.setState({
            openClass: 'footer-panel footer-panel-close',
            panelHidden: !this.state.panelHidden
        })
    }

    bgChange(e) {
        localStorage.setItem('if.carto.bg', e.target.value);
        this.setState({
            mapbg: e.target.value
        });
        let l = this.olmap.getLayers().getArray()[0];
        if (e.target.value === 'sat') {
            l.setSource(this.olSourceSwissImage);
        } else if (e.target.value === 'pixel') {
            l.setSource(this.olSourcePixelMap);
        }
    }

    ugChange(e) {
        localStorage.setItem('if.carto.ug', e.target.value);
        this.setState({
            ug: e.target.value
        });
        if (e.target.value === 'biogeo') {
            this.olmap.removeLayer(this.cantonLayer);
            this.olmap.addLayer(this.biogeoLayer);
        } else if (e.target.value === 'ct') {
            this.olmap.removeLayer(this.biogeoLayer);
            this.olmap.addLayer(this.cantonLayer);
        } else if (e.target.value === 'none') {
            this.olmap.removeLayer(this.cantonLayer);
            this.olmap.removeLayer(this.biogeoLayer);
        }
    }

    yrChange(e) {
        this.setState({
            yearChange: e[0]
        });

        localStorage.setItem('if.carto.yc', e[0]);

        this.olSourceWMS.updateParams({
            year: e[0]
        });

        this.props.yrChangeCallBack(e[0]);
    }

    render() {
        const {locale} = this.state;
        return (
            <div>
                <div id="map" className="map-object">
                    <div ref={this.mousePosition} className="coordinates"/>
                </div>
                <footer className={this.state.openClass}>
                    <div hidden={!this.state.panelHidden}>
                        <button className="button-link footer-panel-open-handle" title={textes.preference[locale]} hidden={!this.state.panelHidden}
                           onClick={this.openPanel}>
                            <GearIcon size="medium"/>
                        </button>
                        <button className="button-link go-to-coords-icon" title={textes.aller[locale]}
                           onClick={this.goToLocation}>
                            <MilestoneIcon size="medium"/>
                        </button>
                        <button className="button-link back-to-full-icon" title={textes.afficher[locale]}
                           onClick={this.zoomBack}>
                            <ScreenFullIcon size="medium"/>
                        </button>
                        <button className="button-link location-icon" title={textes.position[locale]}
                           onClick={this.findLocation}>
                            <LocationIcon size="medium"/>
                        </button>
                        {this.state.dlLink ?
                            <button className="button-link download-map-icon" title={textes.telecharger[locale]}
                               onClick={() => window.open(this.state.dlLink, "_blank")}>
                                <DownloadIcon size="medium"/>
                            </button>
                            :
                            <span className="download-map-icon-disabled">
                                <DownloadIcon size="medium"/>
                            </span>
                        }
                        <div className="footer-right-align">&copy; <a href="https://www.infofauna.ch/" target="_blank"
                                                                      rel="noreferrer noopener">info fauna</a> - <a
                            href="http://www.ville-ge.ch/mhng/cco" target="_blank" rel="noopener noreferrer">CCO</a>/<a
                            href="http://www.fledermausschutz.ch/Schutz/kof.html" target="_blank"
                            rel="noreferrer noopener">KOF</a>, <a href="https://www.swisstopo.admin.ch" target="_blank"
                                                                  rel="noreferrer noopener">swisstopo</a><br/>
                        </div>
                        <div className="footer-version"><small>v{version}</small></div>
                    </div>
                    <div hidden={this.state.panelHidden} className="option-zone">
                        <button hidden={this.state.panelHidden} onClick={this.closePanel}
                           className="button-link footer-panel-close-handle">
                            <XIcon size='medium' verticalAlign='middle' className="footer-panel-icon"/>
                        </button>
                        <Form>
                            <FormGroup>
                                <FormLabel>{textes.fondcarte[locale]}</FormLabel>
                                <select onChange={this.bgChange} className="form-control" value={this.state.mapbg}>
                                    <option key="pixel" value="pixel">{textes.cartepixel[locale]}</option>
                                    <option key="sat" value="sat">{textes.carteaero[locale]}</option>
                                </select>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>{textes.coucheacc[locale]}</FormLabel>
                                <select onChange={this.ugChange} className="form-control"
                                        value={this.state.ug}>
                                    <option key="none" value="none">{textes.aucune[locale]}</option>
                                    <option key="ct" value="ct">{textes.cantons[locale]}</option>
                                    <option key="biogeo" value="biogeo">{textes.biogeo[locale]}</option>
                                </select>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>{textes.annee[locale]}</FormLabel>
                                <Slider
                                    rootStyle={sliderStyle}
                                    domain={[1869, new Date().getFullYear()]}
                                    step={1}
                                    mode={2}
                                    values={[this.state.yearChange]}
                                    onChange={this.yrChange}
                                >
                                    <Rail>
                                        {({getRailProps}) => (  // adding the rail props sets up events on the rail
                                            <div style={railStyle} {...getRailProps()} />
                                        )}
                                    </Rail>
                                    <Handles>
                                        {({handles, getHandleProps}) => (
                                            <div className="slider-handles">
                                                {handles.map(handle => (
                                                    <Handle
                                                        key={handle.id}
                                                        handle={handle}
                                                        getHandleProps={getHandleProps}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </Handles>
                                    <Tracks right={false}>
                                        {({tracks, getTrackProps}) => (
                                            <div className="slider-tracks">
                                                {tracks.map(({id, source, target}) => (
                                                    <Track
                                                        key={id}
                                                        source={source}
                                                        target={target}
                                                        getTrackProps={getTrackProps}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </Tracks>
                                </Slider>
                            </FormGroup>
                        </Form>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Map;
